export const routes = {
  getVoucherDetail: () => `/timesheet/parent/voucher/detail`,
  checkVoucher: () => `/parent/voucher-check`,
};
